import React from "react";
import { map } from "lodash";
import { useNavigate } from "react-router-dom";
import { SituationCard } from "../../../../components";
import { SituationsContainer } from "./styled-components";

const AlertSituationsBloc = ({ data }: { data: Domain }) => {
  const navigate = useNavigate();

  const renderSituationsBloc = () => {
    return map(data.situations, (situation, i) => {
      return (
        <SituationCard
          key={i}
          title={situation.title}
          description={situation.description}
          color={data.color.default}
          onClick={() => {
            if (Number(i) === 0) {
              navigate(`/alerte/${situation.title.toLowerCase()}`);
            } else {
              navigate(`/alerte/${situation.title.toLowerCase()}/orientation`);
            }
          }}
        />
      );
    });
  };

  return <SituationsContainer>{renderSituationsBloc()}</SituationsContainer>;
};

export default AlertSituationsBloc;
